import AXIOS from '@/axios-instance';

export default {

  saveComment(uuid, elementId, text) {
    return AXIOS.post("/comment", {
      text: text,
      uuidModel: uuid,
      elementId: elementId,
    });
  },
  retrieveComments(uuidModel, elementId) {
    return AXIOS.get("/comment/bpmn/"+uuidModel+"/element/"+elementId);
  },
  deleteComment(commentId){
    return AXIOS.delete("/comment/" + commentId);
  }
}